<template>
    <div>
        <h4 class="ticket-group-title" v-if="group.title">{{ group.title }}</h4>

        <!--Ticket View-->
        <template v-if="view==='tickets'">
            <ticket v-for="registrationCategory in registrationCategories"
                    :registration-category="registrationCategory"></ticket>
        </template>

        <!--Table-->
        <div class="card mb-4" v-else>
            <div class="card-body px-0 py-0">
                <table-container :registration-categories="group.registration_categories"></table-container>
            </div>
        </div>
    </div>
</template>

<script>
import Ticket from "./Ticket/Ticket";
import TableContainer from "./Table/TableContainer";

export default {
    name: "Group",
    components: {
        TableContainer,
        Ticket,
    },
    props: {
        group: {
            type: Object,
            default: () => {
                {
                }
            },
            required: true,
        },
        view: {
            type: String,
            default: 'tickets',
            required: false
        }
    },
    computed: {
        registrationCategories() {
            // Sort by priority
            return this.group.registration_categories.sort(function(a, b){
                return a.priority - b.priority
            })
        }
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Group.vue